// main.js
import { createApp } from "vue";
import App from "./App.vue";
import "./assets/mra.scss";
import "@/assets/mra-styles.css";

import router from "./router/index.js";
import i18n from "./i18n";
import { useCtaHref } from "@/utils/ctaHref";

// add this import
import { ensureGlobals, ensureNs } from "./i18n/load";

// Surface runtime errors loudly during your local test
window.addEventListener("error", (e) => {
  console.error("[window.error]", e.error || e.message, e);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("[unhandledrejection]", e.reason || e);
});

const app = createApp(App);
app.use(router).use(i18n);

// 🔎 INSERT PRE-FLIGHT HERE (before mount)
if (location.search.includes("i18ncheck=1")) {
  const LOCALES = ["en", "cy"];
  const NAMESPACES = [
    "home",
    "foreword",
    "mission",
    "vision",
    "dfc",
    "es",
    "fftf",
    "gptw",
    "wwo",
    "overview",
  ];
  (async () => {
    try {
      for (const loc of LOCALES) {
        await ensureGlobals(loc);
        for (const ns of NAMESPACES) await ensureNs(ns, loc);
      }
      console.log("[i18n preflight] all good");
    } catch (e) {
      console.error("[i18n preflight FAILED]", e);
      alert(`[i18n preflight FAILED]\n${e?.message || e}`);
    }
  })();
}

// expose globally for templates as `$ctaHref(...)`
app.config.globalProperties.$ctaHref = (...args) => {
  const { ctaHref } = useCtaHref();
  return ctaHref(...args);
};

// Build a locale-aware, section-aware URL from a translation key like "vision.cta"
app.config.globalProperties.$href = function (key, opts = {}) {
  const section = opts.section || "business-plan";
  const origin =
    typeof window !== "undefined" && window.location && window.location.origin
      ? window.location.origin
      : "";
  const locale =
    (this && this.$route && this.$route.params && this.$route.params.locale) ||
    (this && this.$i18n && this.$i18n.locale) ||
    "en";

  let raw = "";
  if (this && typeof this.$t === "function") {
    const k = key.endsWith(".href") ? key : `${key}.href`;
    raw = this.$t(k) || "";
  }
  if (/^https?:\/\//i.test(raw)) return raw;

  const path = String(raw).replace(/^\/+/, "");
  const url = [origin, locale, section, path].filter(Boolean).join("/");
  return url.replace(/([^:]\/)\/+/g, "$1");
};

app.mount("#app");
